import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import methodModel from "../../methods/methods";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { toast } from "react-toastify";
import { login_success } from "../../actions/user";

export default function EditProfile() {
  const user = useSelector((state) => state.user);
  const [form, setForm] = useState({
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    companyName: user?.companyName || "",
    mobileNo: user?.mobileNo || "",
    address: user?.address || "",
    image: user?.image || "",
    state: user?.state || "",
    country: user?.country || "",
    pinCode: user?.pinCode || "",
    id: user?.id || user?._id,
  });
  const history = useNavigate();
  const dispatch = useDispatch();
  const [submitted, setsubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handlePinCodeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setForm({ ...form, pinCode: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setsubmitted(true);

    let value = { ...form };
    delete value.email;
    if (form?.mobileNo) {
      value.mobileNo = form.mobileNo.replaceAll("+", "");
    }

    loader(true);

    ApiClient.put("user/profile", value).then((res) => {
      if (res.success) {
        toast.success(res.message);
        const data = { ...user, ...res?.data?.updatedUser };
        dispatch(login_success(data));
        setsubmitted(false);
        history("/profile");
      }
      loader(false);
    });
  };

  const ImageUpload = (e) => {
    let file = e.target.files[0];

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG and PNG images are allowed.");

      return;
    }

    loader(true);

    ApiClient.postFormData("upload/image", { file }).then((res) => {
      if (res.success) {
        toast.success(res.message);
        setForm({ ...form, image: res?.fileName });
        setsubmitted(false);
      }
      loader(false);
    });
  };

  return (
    <>
      <Header />

      <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px]">
        <form onSubmit={handleSubmit}>
          <div className="container mx-auto py-8 lg:py-14 px-5">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-gray-800">Profile</h2>
              <Link to="/profile">
                <button
                  type="button"
                  className="flex gap-2 items-center justify-center bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white rounded-full text-sm hover:scale-[1.04] duration-300 transition px-5 py-2.5"
                >
                  Back
                </button>
              </Link>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 py-8 px-5 md:px-8 overflow-hidden text-center min-h-[308px] h-fit">
                <div className="h-16 bg-gradient-to-r from-[#115B9D] to-[#116DAE] rounded-xl mb-[-40px]"></div>

                <label className="cursor-pointer">
                  <img
                    src={methodModel.userImg(form.image)}
                    className="w-28 h-28 rounded-full mx-auto object-cover mb-4 border-4 border-white shadow-lg relative z-10 bg-white"
                  />
                  <input type="file" hidden onChange={ImageUpload} />
                </label>

                <h3 className="text-xl font-semibold text-gray-800 capitalize">
                  {user.firstName} {user.lastName}
                </h3>

                <p className="text-gray-500 text-sm mb-3">{form.email}</p>
              </div>

              {/* Form */}
              <div className="lg:col-span-2 bg-white rounded-2xl shadow-md border border-gray-100 py-8 px-5 md:px-8">
                <h3 className="text-sm font-semibold text-[#115B9D] uppercase tracking-widest mb-5">
                  Personal Information
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="text-sm text-gray-600">First Name</label>
                    <input
                      name="firstName"
                      value={form.firstName}
                      onChange={handleChange}
                      required
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-gray-600">Last Name</label>
                    <input
                      name="lastName"
                      value={form.lastName}
                      onChange={handleChange}
                      required
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-gray-600">Email</label>
                    <input
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      disabled
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-gray-600">Mobile</label>
                    <div className="phoneinput mt-1">
                      <PhoneInput
                        required
                        enableSearch={true}
                        autoFormat={false}
                        placeholder="Enter phone number"
                        value={form?.mobileNo}
                        countryCodeEditable={true}
                        onChange={(e) => setForm({ ...form, mobileNo: e })}
                        buttonClass="!rounded-l-xl border !border-[#e5e7eb]"
                        inputClass="!rounded-xl !min-h-[44px] border !border-[#e5e7eb]"
                      />
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <label className="text-sm text-gray-600">Address</label>
                    <textarea
                      name="address"
                      value={form.address}
                      onChange={handleChange}
                      required
                      rows="3"
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 mt-1"
                    ></textarea>
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">State</label>
                    <input
                      type="text"
                      name="state"
                      value={form.state}
                      onChange={handleChange}
                      required
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">Country</label>
                    <input
                      type="text"
                      name="country"
                      value={form.country}
                      onChange={handleChange}
                      required
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">Pin Code</label>
                    <input
                      type="text"
                      name="pinCode"
                      value={form.pinCode}
                      onChange={handlePinCodeChange}
                      required
                      className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                    />
                  </div>
                  {/* <div>
                  <label className="text-sm text-gray-600">Company</label>
                  <input
                    type="text"
                    name="companyName"
                    value={form.companyName}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-200 h-11 mt-1"
                  />
                </div> */}
                </div>
              </div>
            </div>

            <div className="mt-8 flex justify-end">
              <button
                type="submit"
                className="flex gap-2 items-center justify-center bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white rounded-full text-sm hover:scale-[1.04] duration-300 transition px-5 py-2.5"
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </div>

      {methodModel.TokenChecker() && <Footer />}
    </>
  );
}
